import React from 'react';

import NotLogin from 'pages/Layout/NotLogin';
import ResetPasswordContent from 'pages/Modules/ExpressLogin/ResetPassword';

const ResetPassword = () => {
  return (
    <NotLogin>
      <ResetPasswordContent />
    </NotLogin>
  );
};

export default ResetPassword;
